import React from 'react'
import './Home.css';


const Home = () => {
  return (
    <div>
        <section className='home' id='home'>
            <div className='home-content'>
              <h3>Hi, I am</h3>
              <h1>lakshan Hewagama</h1>
              <h3><span>Fullstack Developer</span></h3>
              <p>B.Sc. (Hons) Software Engineering | Developer & Tech Enthusiast | MERN & Next.js</p>
       
                <div className='social-media'>                
                  <a href='https://www.linkedin.com/in/lakshan-hewagama-0918b930a/' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                  <a href='https://github.com/LakshanHewagama' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-github"></i></a>                
                  <a href='https://medium.com/@lakshanhewagama' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-medium"></i></a>
                  <a href='https://web.facebook.com/lakshanhewagama/' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-facebook"></i></a>
                  <a href='https://www.instagram.com/lakshan_hewagama/' target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-instagram"></i></a>
                </div>
                  <a href='/File/LakshanHewagamaCV.pdf' className='btn'>Download CV</a>
            </div>     

            <div className='home-img'>
                <img src='profile.png' alt='profile'></img>
            </div>     
        </section>

    </div>
  )
}

export default Home